import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import React from 'react';
import useIsMobile from '../../../hooks/useIsMobile';
import MobileHorizontalScrollerBox from '../../../components/boxes/MobileHorizontalScrollerBox';
import OperationsSummaryCard from './OperationsSummaryCard';

const OperationsStatusSummary = ({
  getCards, summary, loading, extraComponents,
}) => {
  const isMobile = useIsMobile();
  const cards = getCards(summary);

  return (
    <Grid item xs={12}>
      <MobileHorizontalScrollerBox
        isMobile={isMobile}
        alignItems="center"
        justifyContent="space-between"
        sx={{
          bgcolor: 'gray.A100',
          borderRadius: 2,
          padding: { xs: 1, md: 2 },
        }}
      >
        <Stack direction="row" spacing={2} alignItems="stretch">
          {cards.map((card) => (
            <Box key={card.key} sx={{ width: { xs: 160, md: 200 }, flexShrink: 0 }}>
              <OperationsSummaryCard
                label={card.label}
                count={card.count}
                value={card.value}
                isWarning={card.isWarning}
                loading={loading}
                tooltipText={card.tooltipText}
              />
            </Box>
          ))}
        </Stack>
        {extraComponents && (
          <Stack direction="row" spacing={1.5} alignItems="center">
            {extraComponents}
          </Stack>
        )}
      </MobileHorizontalScrollerBox>
    </Grid>
  );
};

OperationsStatusSummary.propTypes = {
  getCards: PropTypes.func.isRequired,
  summary: PropTypes.shape({}),
  loading: PropTypes.bool,
  extraComponents: PropTypes.node,
};

OperationsStatusSummary.defaultProps = {
  summary: undefined,
  loading: false,
  extraComponents: null,
};

export default OperationsStatusSummary;
